<template>
  <div class="container">
    <div class="jumbotron m-3">
      <h2 class="mb-5 text-center">Cadastro de Notícia</h2>

      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Título</label>
          <input
            type="text"
            class="form-control"
            name="titulo"
            v-model="post.titulo"
            maxlength="25"
          />
        </div>
        <div class="form-group col-md-4">
          <label>Assunto</label>
          <input
            type="text"
            class="form-control"
            name="assunto"
            v-model="post.assunto"
            maxlength="150"
          />
        </div>
        <div class="form-group col-md-4">
          <label>Categoria</label>
          <select
            class="form-control form-control-md"
            name="categoriaId"
            v-model="post.categoriaId"
          >
            <option
              v-for="categoria in categorias"
              v-bind:key="categoria.categoriaId"
              v-bind:value="categoria.categoriaId"
            >{{ categoria.titulo }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label>Imagem Principal</label>
        <div class="input-group">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              v-on:change="fileToPostMensagem"
              id="inputGroupFile01"
              aria-describedby="inputGroupFileAddon01"
              lang="pt-BR"
            />
            <label class="custom-file-label" for="inputGroupFile01">{{ nomeArquivo }}</label>
          </div>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Mensagem</label>
        <quill-editor v-model="post.mensagem" :config="editorOption"></quill-editor>
      </div>
      <div class="col-md-12 text-center">
        <button type="button" class="btn btn-primary" v-on:click="addPost" v-if="!dialog">Cadastrar</button>
        <v-progress-circular :size="50" color="primary" indeterminate v-if="dialog"></v-progress-circular>
      </div>
    </div>
    <notifications group="camposInvalidos" position="bottom center" :speed="500" />
    <notifications group="erroCadastrar" position="bottom center" :speed="500" />
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";

import router from "../router";
import EventBus from "./EventBus";
export default {
  name: "CriarPosts",
  data() {
    return {
      categorias: [],
      editorOption: {},
      nomeArquivo: "",
      dialog: false,
      post: {
        postId: 0,
        titulo: "",
        categoriaId: 0,
        assunto: "",
        mensagem: "",
        imagem: "",
        dataPublicacao: null,
      },
    };
  },
  mounted() {
    this.getCategorias();
    this.post.mensagem = "<h3> Digite o corpo da notícia aqui... </h3>";
  },
  methods: {
    getCategorias() {
      axios.get("https://www.sabios.net.br/api/categoria").then(
        (rs) => {
          this.categorias = rs.data;
        },
        (err) => console.log("Error: " + err)
      );
    },
    fileToPostMensagem(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.post.imagem = reader.result;
      };
      this.nomeArquivo = file.name;
    },
    addPost() {
      let camposInvalidos = this.validarForm();
      if (camposInvalidos != "") {
        this.$notify({
          group: "camposInvalidos",
          title: "Formulário Inválido!",
          text: `Campo: ${camposInvalidos}`,
          type: "error",
        });
        return;
      }
      this.dialog = true;

      let post = {
        titulo: this.post.titulo,
        categoriaId: this.post.categoriaId,
        assunto: this.post.assunto,
        mensagem: this.post.mensagem,
        imagem: this.post.imagem,
        dataPublicacao: new Date(),
      };

      axios.post("https://www.sabios.net.br/api/post", post).then(
        (rs) => {
          if (!rs.data.toString().match("Erro")) {
            this.limparForm();
            this.emitMethod();
            router.push({ name: "ListarPosts" }).catch(() => {});
          } else {
            this.$notify({
              group: "erroCadastrar",
              title: "Erro ao cadastrar notícia!",
              text: "Entre em contato com a LH Tech!",
              type: "error",
            });
            this.dialog = false;
          }
        },
        (err) => {
          this.$notify({
            group: "erroCadastrar",
            title: "Erro ao cadastrar notícia!",
            text: "Entre em contato com a LH Tech!",
            type: "error",
          });
          this.dialog = false;
          console.log("Error: " + err);
        }
      );
    },
    validarForm() {
      let campos = "";

      if (this.post.titulo.trim() === "") campos = "Título Obrigatório";
      else if (this.post.assunto.trim() === "") campos = "Assunto Obrigatório";
      else if (this.post.categoriaId === 0) campos = "Categoria Obrigatório";
      else if (this.post.mensagem.trim() === "")
        campos = "Mensagem Obrigatório";
      else if (this.post.imagem.trim() === "")
        campos = "Imagem Principal Obrigatório";

      return campos;
    },
    limparForm() {
      this.post.titulo = "";
      this.post.categoriaId = "";
      this.post.assunto = "";
      this.post.mensagem = "";
      this.post.imagem = "";
      this.post.dataPublicacao = null;
    },
    emitMethod() {
      EventBus.$emit("noticia", "cadastrada");
    },
  },
};
</script>
<style scoped>
.custom-file-input ~ .custom-file-label::after {
  content: "Selecione...";
}

.quill-editor,
.content {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/CriarPosts.vue